// extracted by mini-css-extract-plugin
export default {"ApproveButton":"_ApproveButton--V6xzR","SmallExpanded":"_SmallExpanded--STVOD"};